module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-2-6e0ad27a3368df48e3308736b0e64c0d.webp";